import { useRef, useCallback, useEffect, HTMLProps, useId } from 'react';

type Politeness = HTMLProps<HTMLElement>['aria-live'];

export function useAnnouncer(politeness: Politeness = 'polite') {
  const id = useId();
  const elRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = document.createElement('div');
    el.id = id;
    el.className = 'sr-only';
    el.setAttribute('aria-live', politeness);
    el.setAttribute('aria-atomic', 'true');
    el.setAttribute('role', 'status');
    el.style.cssText = `
      position: absolute; width: 1px; height: 1px;
      padding: 0; overflow: hidden;
      clip: rect(0,0,0,0); white-space: nowrap; border: 0;
    `;
    document.body.appendChild(el);
    elRef.current = el;
    return () => void document.body.removeChild(el);
  }, [politeness]);

  const announce = useCallback((message: string) => {
    const el = elRef.current;
    if (!el) return;
    el.textContent = '';
    requestAnimationFrame(() => {
      el.textContent = message;
    });
  }, []);

  return announce;
}
